import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from 'react-redux'
import Box from '@mui/material/Box';
import { format } from 'date-fns'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';


import {
    selectDefaultMenuGroups,
    getMenuGroupStatus,
    getMenuGroupError,
    fetchImportPreview,
    
} from '../../store/browseMenuItemsSlice'
import { useHistory, useParams } from 'react-router-dom'

import { BRANDS_URL_PREFIX, FLAG_URL_PREFIX, SCREENGRAB_URL_PREFIX, MENU_URL_PREFIX } from "../../components/shared/Constants";

export default function ReviewReport() {

    const { groupId } = useParams()

    const menuitemgroups = useSelector(selectDefaultMenuGroups);
    const menugroupStatus = useSelector(getMenuGroupStatus);
    const menugroupError = useSelector(getMenuGroupError);
    const [updatedItems, setUpdatedItems] = useState({});

    const dispatch = useDispatch();
    useEffect(() => {
        if (menugroupStatus === 'idle') {
            try {
                dispatch(fetchImportPreview(groupId))
            } catch (err) {
                console.log(err)
            }
        }

    }, [menugroupStatus, dispatch, groupId])

    // Show loading indicator while data is being fetched
    if (menugroupStatus === 'loading') {
        return (
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: '50vh' }}
            >
                <CircularProgress color="success" />
            </Grid>
        );
    }

    // Show error message if fetch failed
    if (menugroupStatus === 'failed') {
        return (
            <Container>
                <Typography variant="h6" color="error" sx={{ mt: 2 }}>
                    Error loading menu items: {menugroupError || 'Unknown error'}
                </Typography>
            </Container>
        );
    }

    const setDefaultImage = async (itemId) => {
        try {
            const response = await fetch(`/api/menuitems/SetDefaultImage/${itemId}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            });
            
            if (!response.ok) {
                alert('Failed to set default image');
                return;
            }
            
            const updatedItem = await response.json();
            console.log('SetDefaultImage result:', updatedItem);
            
            // Update local state with the updated item
            setUpdatedItems(prev => ({
                ...prev,
                [itemId]: updatedItem
            }));
        } catch (error) {
            alert('Error: ' + error.message);
        }
    };


    return (

        <>
          
            {menuitemgroups.map(group => (

                <Container
                    key={group.id}
                    sx={{
                        maxWidth: "1340px",
                        display: 'flex',
                        flexDirection: 'column',
                        mt: 2,
                        mb: 2,
                    }} fixed>
                    <Typography gutterBottom variant="body2" component="div" sx={{ mt: 1, mr: 1 }}>
                        GROUP ID:   {group.id}
                    </Typography>
                    {group.menuItems?.map(item => {
                        // Use updated item if available, otherwise use the original
                        const displayItem = updatedItems[item.id] || item;
                        
                        return (
                        <Box id={group.id} sx={{
                            alignItems: 'flex-start',
                            display: 'flex',
                            borderTop: '2px solid #afafaf',
                            pt: 2,
                            pb: 2,
                        }} className="menu-item-row" key={item.id}>

                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mr: 2 }}>
                                {(() => {
                                    if (displayItem.blobImageName !== undefined && displayItem.blobImageName !== '') {
                                        return (<img className="menu-item-row--menu-thumbnail" src={MENU_URL_PREFIX
                                            + format(new Date(group.dateForRange), 'yyyy') + '/'
                                            + format(new Date(group.dateForRange), 'MMM').toLowerCase() + '/'
                                            + (group.countryNavigation.countryShortName).replace(/\s/g, "-").toLowerCase()
                                            + '/' + displayItem.blobImageName} />)
                                    } else if (displayItem.useDefaultImage?.trim() === "yes" || displayItem.useDefaultImage === "1") {
                                        return (<img className="menu-item-row--menu-thumbnail" src="/images/default-ppt.png" />)

                                    } else if (displayItem.screenshot !== undefined && displayItem.screenshot !== '') {
                                        //screengrab 
                                        return (<img className="menu-item-row--menu-thumbnail" src={SCREENGRAB_URL_PREFIX
                                            + format(new Date(group.dateForRange), 'yyyy') + '/'
                                            + format(new Date(group.dateForRange), 'MMM').toLowerCase() + '/'
                                            + (group.country)
                                            + '/' + displayItem.screenshot} />)
                                    } else {
                                        return (<img className="menu-item-row--menu-thumbnail" src="/images/default-ppt.png" />)

                                    }
                                })()}

                                {(displayItem.useDefaultImage?.trim() !== 'yes' && displayItem.useDefaultImage !== '1') && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={() => setDefaultImage(displayItem.id)}
                                        sx={{ textTransform: 'none', mt: 1, fontSize: '0.75rem', py: 0.5 }}
                                    >
                                        Use Default
                                    </Button>
                                )}
                                {(displayItem.useDefaultImage?.trim() === 'yes' || displayItem.useDefaultImage === '1') && (
                                    <Typography variant="caption" color="success.main" sx={{ mt: 1, fontWeight: 500 }}>
                                        ✓ Default
                                    </Typography>
                                )}
                            </Box>

                            <Box className="menu-item-row--details"
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%'
                                }}>
                                <Typography gutterBottom variant="h4" component="div" sx={{ mt: 1, mr: 1, mb: 0 }}>
                                    <em>{displayItem.menuItemName}</em>
                                </Typography>

                                <Box sx={{
                                    flexDirection: 'row',
                                    display: 'flex'
                                }}>
                                    <Typography gutterBottom variant="body2" component="div" sx={{ mt: 1, mr: 1 }}>
                                        Brand:
                                    </Typography>
                                    {(() => {
                                        if (displayItem.brandNavigation?.brandLogo !== undefined && displayItem.brandNavigation?.brandLogo !== null && displayItem.brandNavigation?.brandLogo !== '') {
                                            return <img className="menu-item-row--brand-thumbnail" src={BRANDS_URL_PREFIX +
                                                displayItem.brandNavigation.brandLogo} />;
                                        }
                                        // } else {
                                        //     return <img className="menu-item-row--brand-thumbnail" src="/images/blank.png"/>;
                                        // }
                                    })()}

                                    <Typography gutterBottom variant="body2" component="div" sx={{ mt: 1, mr: 1 }}>
                                        &nbsp;{displayItem.brandNavigation?.brandName}
                                    </Typography>
                                    <Typography gutterBottom variant="body2" component="div" sx={{ mt: 1, mr: 1 }}>
                                        | &nbsp;&nbsp;Meal Part: {displayItem.mealPartNavigation?.mealPartName}
                                    </Typography>
                                    <Typography gutterBottom variant="body2" component="div" sx={{ mt: 1, mr: 1 }}>
                                        | &nbsp;&nbsp;Day Part: {displayItem.dayPartNavigation?.dayPartName}
                                    </Typography>
                                    <Typography gutterBottom variant="body2" component="div" sx={{ mt: 1, mr: 1 }}>
                                        | &nbsp;&nbsp;Country:
                                    </Typography>
                                    <img className="menu-item-row--flag-thumbnail" src={FLAG_URL_PREFIX + group.countryNavigation.countryFlagImage} />
                                    <Typography gutterBottom variant="body2" component="div" sx={{ mt: 1, mr: 1 }}>
                                        {group.countryNavigation.countryShortName}
                                    </Typography>
                                    <Typography gutterBottom variant="body2" component="div" sx={{ mt: 1 }}>
                                        |  &nbsp;&nbsp;Launched: {format(new Date(group.dateForRange), 'MMMM')}
                                        {format(new Date(group.dateForRange), 'yyyy')}
                                    </Typography>

                                </Box>

                                <Typography gutterBottom variant="body2" component="div" sx={{ mt: 1, mr: 1 }}>
                                    {displayItem.description}
                                </Typography>
                            </Box>
                        </Box>
                        );
                    })}
                </Container>
            ))}
        </>
    )
}